import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

const home = r => require.ensure([],() => r(require('../pages/home/home')),'home');	//最后面home 为一次所加载的 路由块，所以可以有多个

const about = r => require.ensure([],() => r(require('../pages/about/about')),'about');	

const products = r => require.ensure([],() => r(require('../pages/products/products')),'products');	
const productDef = r => require.ensure([],() => r(require('../pages/products/children/productDefault')),'products');	
const productDeta = r => require.ensure([],() => r(require('../pages/products/children/productDetails')),'products');	

const solution = r => require.ensure([],() => r(require('../pages/solution/solution')),'solution');	
const soluDef = r => require.ensure([],() => r(require('../pages/solution/children/soluDefault')),'solution');	
const soluDeta = r => require.ensure([],() => r(require('../pages/solution/children/soluDetails')),'solution');	

const info = r => require.ensure([],() => r(require('../pages/information/information')),'information');	
const infoDef = r => require.ensure([],() => r(require('../pages/information/children/infoDefault')),'information');	
const infoDeta = r => require.ensure([],() => r(require('../pages/information/children/infoDetails')),'information');	

const resource = r => require.ensure([],() => r(require('../pages/resource/resource')),'resource');	

const recruit = r => require.ensure([],() => r(require('../pages/recruit/recruit')),'recruit');	
const recruitDef = r => require.ensure([],() => r(require('../pages/recruit/children/recruitDefault')),'recruit');	
const recruitDeta = r => require.ensure([],() => r(require('../pages/recruit/children/recruitDetails')),'recruit');	

const contact = r => require.ensure([],() => r(require('../pages/contact/contact')),'contact');	








export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    // 首页
    {
      path:'/home',
      name:'home',
      component:home
    },
    // 关于中尔
    {
      path:'/about',
      component:about
    },
    // 产品介绍
    {
      path:'/products',
      component:products,
      children:[
        {path:'/',component:productDef},
        // 默认产品列表
        {path:'def',component:productDef},
        // 详情
        {path:'details/:lis',component:productDeta}
        
      ]
    },
    // 解决方案
    {
      path:'/solution',
      component:solution,
      children:[
        {path:'/',component:soluDef},
        {path:'def',component:soluDef},
        {path:'details/:lis',component:soluDeta}
      ]
    },
    // 企业讯息
    {
      path:'/info',
      component:info,
      children:[
        {path:'/',component:infoDef},
        {path:'def',component:infoDef},
        {path:'details/:lis',component:infoDeta},
      ]
    },
    // 资源下载
    {
      path:'/resource',
      component:resource
    },
    // 招聘
    {
      path:'/recruit',
      component:recruit,
      children:[
        {path:'/',component:recruitDef},
        {path:'def',component:recruitDef},
        {path:'details/:lis',component:recruitDeta}
      ]
    },
    // 联系我们
    {
      path:'/contact',
      component:contact
    },


    // *
    {
      path:'*',
      redirect:'/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js